import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getRCOPICKINGLISTTableStructure";
export const UPDATE_TABLE_DATA = "updateRCOPICKINGLISTTableData";
export const EXPORT_TABLE_DATA = "exportRCOPICKINGLISTTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setRCOPICKINGLISTTableStructure";
export const SET_TABLE_DATA = "setRCOPICKINGLISTTableData";
export const SET_TABLE_PAGE = "setRCOPICKINGLISTTablePage";
export const SET_TABLE_PERPAGE = "setRCOPICKINGLISTTablePerPage";
export const SET_TABLE_FILTER = "setRCOPICKINGLISTTableFilter";
export const SET_EXPORT_LINK = "setRCOPICKINGLISTExportLink";

const state = {
  export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  getRCOPICKINGLISTTableProperties(state) {
    return state.table_structure.properties;
  },
  getRCOPICKINGLISTTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getRCOPICKINGLISTTableState(state) {
    return state.table_state;
  },
  getRCOPICKINGLISTTableData(state) {
    return state.table_data.data;
  },
  getRCOPICKINGLISTTableHeaders(state) {
    return state.table_structure.columns;
  },
  getRCOPICKINGLISTTableFilters(state) {
    return state.table_structure.filters;
  },
  getRCOPICKINGLISTExportUrl(state) {
    return state.export_link;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    return new Promise((resolve) => {
      ApiService.post("/warehouse_management/rco_picking_lists")
        .then(({ data }) => {
          data.data.columns.pop(); // remove the actions from reponse
          context.commit(SET_TABLE_STRUCTURE, data);
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post(
        "/warehouse_management/rco_picking_lists/datatable",
        payload
      )
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);
          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/warehouse_management/rco_picking_lists/export", payload)
        .then(({ data }) => {
          // console.log("export data is ", data);
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
